import React, { ReactElement } from 'react';

import { SerializedStyles } from '@emotion/react';

import Button from '@components/common/Button';

import {
  containerStyle,
  buttonGroupStyle,
  buttonStyle,
} from './ConfirmModal.style';

interface ComfirmModalPropsType {
  textLineList: string[] | undefined;
  children?: ReactElement;
  onHide: () => void;
  onClick?: () => void;
  isShowCancelButton?: boolean;
  isShowConfirmButton?: boolean;
  style?: SerializedStyles;
  cancelButtonText?: string;
  confirmButtonText?: string;
}

function ConfirmModal({
  textLineList,
  children,
  onHide,
  onClick,
  isShowCancelButton = true,
  isShowConfirmButton = true,
  style,
  cancelButtonText = '취소',
  confirmButtonText = '확인',
}: ComfirmModalPropsType): ReactElement {
  return (
    <div
      role="dialog"
      aria-labelledby="dialogTitle"
      aria-describedby="dialogContent"
      css={[containerStyle, style]}
    >
      {textLineList?.map((text) => (
        <span key={text} className="lineChange">
          {text}
        </span>
      ))}

      {children}

      <div css={buttonGroupStyle}>
        {isShowCancelButton && (
          <Button css={buttonStyle} type="link" onClick={onHide}>
            {cancelButtonText}
          </Button>
        )}

        {isShowConfirmButton && (
          <Button
            css={buttonStyle}
            type="link"
            replace={true}
            onClick={() => {
              if (onClick) onClick();
              onHide();
            }}
          >
            {confirmButtonText}
          </Button>
        )}
      </div>
    </div>
  );
}

export default ConfirmModal;
